import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { FileTextIcon, ListChecksIcon, TargetIcon, MessageSquareIcon, ZapIcon, ShieldCheckIcon, TrendingUpIcon } from 'lucide-react';
const features = [{
  icon: FileTextIcon,
  title: 'Guía Paso a Paso',
  description: 'El mapa exacto para moverte de cero a venta.'
}, {
  icon: ListChecksIcon,
  title: 'Checklist de Preparación',
  description: 'No lances nada sin marcar estas casillas de éxito.'
}, {
  icon: TargetIcon,
  title: 'Hoja de Ruta de Contactos',
  description: 'El filtro para encontrar quién tiene el dinero listo para ti.'
}, {
  icon: MessageSquareIcon,
  title: 'Scripts de Mensaje Directo',
  description: 'Palabras exactas para copiar, pegar y cerrar.'
}, {
  icon: ZapIcon,
  title: 'Plantilla de Oferta Flash',
  description: 'La estructura de urgencia que obliga a tomar decisiones.'
}, {
  icon: ShieldCheckIcon,
  title: 'Guía de Objeciones',
  description: 'Qué decir cuando te dicen "no tengo dinero" o "no tengo tiempo".'
}, {
  icon: TrendingUpIcon,
  title: 'Registro de Resultados',
  description: 'La herramienta para medir tu éxito y escalar.'
}];
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-16 md:py-24 bg-[#faf8f5]" data-id="element-115">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-117">
          <div className="text-center space-y-4" data-id="element-118">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1e3a8a]" data-id="element-119">
              Qué Obtienes
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-120">
              Todo lo que necesitas para generar tu primera venta en las
              próximas 48 horas
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-12" data-id="element-121">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: 0.2,
            duration: 0.6
          }} data-id="element-122">
              <img src="https://cdn.magicpatterns.com/uploads/2cFLvjKAH4dXss15rrTFnH/portada.png" alt="Primeras Ventas en 48 Horas" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-123" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: 0.2,
            duration: 0.6
          }} className="space-y-6" data-id="element-124">
              {features.slice(0, 4).map((feature, index) => {
              const Icon = feature.icon;
              return <motion.div key={index} initial={{
                opacity: 0,
                y: 20
              }} animate={isInView ? {
                opacity: 1,
                y: 0
              } : {}} transition={{
                delay: 0.3 + index * 0.1,
                duration: 0.5
              }} className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-125">
                    <div className="bg-[#f97316] p-3 rounded-lg flex-shrink-0" data-id="element-126">
                      <Icon className="w-6 h-6 text-white" data-id="element-127" />
                    </div>
                    <div data-id="element-128">
                      <h3 className="text-xl font-bold text-[#1e3a8a] mb-2" data-id="element-129">
                        {feature.title}
                      </h3>
                      <p className="text-gray-700" data-id="element-130">{feature.description}</p>
                    </div>
                  </motion.div>;
            })}
            </motion.div>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-131">
            {features.slice(4).map((feature, index) => {
            const Icon = feature.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              delay: 0.5 + index * 0.1,
              duration: 0.5
            }} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all hover:scale-105" data-id="element-132">
                  <div className="bg-[#f97316] p-3 rounded-lg inline-block mb-4" data-id="element-133">
                    <Icon className="w-6 h-6 text-white" data-id="element-134" />
                  </div>
                  <h3 className="text-xl font-bold text-[#1e3a8a] mb-2" data-id="element-135">
                    {feature.title}
                  </h3>
                  <p className="text-gray-700" data-id="element-136">{feature.description}</p>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}